import { z } from 'zod';
/**
 * The kinds of output a fingerprint conjecture produces, and the axis a scenario search filters on.
 * Fingerprint is the service that computes them; primary is the only place they are stated in
 * TypeScript, because it proxies the whole scenario surface.
 */
export var FingerprintOutputKind;
(function (FingerprintOutputKind) {
    FingerprintOutputKind["Authorization"] = "AUTHORIZATION";
    FingerprintOutputKind["Flags"] = "FLAGS";
    FingerprintOutputKind["Flows"] = "FLOWS";
    FingerprintOutputKind["Forms"] = "FORMS";
    FingerprintOutputKind["Jobs"] = "JOBS";
    FingerprintOutputKind["NoteTemplates"] = "NOTE_TEMPLATES";
    /** Superseded by `Notifications`; kept because stored scenarios still name it. */
    FingerprintOutputKind["NotificationContents"] = "NOTIFICATION_CONTENTS";
    FingerprintOutputKind["Notifications"] = "NOTIFICATIONS";
    FingerprintOutputKind["PatientProblems"] = "PATIENT_PROBLEMS";
    FingerprintOutputKind["PostVisits"] = "POST_VISITS";
    FingerprintOutputKind["PreRegistrations"] = "PRE_REGISTRATIONS";
    FingerprintOutputKind["ProblemGroups"] = "PROBLEM_GROUPS";
    FingerprintOutputKind["RemoveFeedItems"] = "REMOVE_FEED_ITEMS";
})(FingerprintOutputKind || (FingerprintOutputKind = {}));
export const FingerprintOutputKindSchema = z.enum(FingerprintOutputKind);
//# sourceMappingURL=outputKind.js.map